export const GET_ALL_CRAWL_DATA = "/admin/v1/all-crawl-data-v1016";
export const GET_ALL_CRAWL_CARD_DATA = "/admin/v1/all-cards-ref";
export const ASSIGN_CARD_TO_CARD_REF = "/admin/v1/card-ref/assign";
export const CONFIRM_DISCONTINUED_CARD = "/admin/v1/update_card";
export const DISMISS_CARD_REF = "/admin/v1/card-ref/dismiss";
export const VERIFY_CARDS = "/admin/v1/verify-crawl-data";
